<template>
  <div class="login">
    <div class="login-top"/>
    <div class="login-con">
      <img src="../../../public/img/newLoginTop.png">
      <el-card>
        <div slot="header">
          <span>欢迎访问新时达电气MES</span>
        </div>
        <el-form ref="loginForm" :model="user" :rules="rules">
          <el-form-item prop="username">
            <el-input v-model="user.username" placeholder="请输入账号" size="medium">
              <template slot="prepend">账　号</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
                v-model="user.password"
                placeholder="请输入密码"
                type="password"
                size="medium"
                show-password>
              <template slot="prepend">密　码</template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="showCaptcha" prop="captcha">
            <div style="display: flex">
              <el-input
                  v-model="user.captcha"
                  placeholder="请输入验证码"
                  size="medium"
                  clearable
                  maxlength="4">
                <template slot="prepend">验证码</template>
              </el-input>
              <img :src="captchaImg" style="height: 36px;margin-left: 5px" @click="getCaptcha()">
            </div>
          </el-form-item>
          <!--          <div>-->
          <!--            <el-radio-group v-model="user.loginType">-->
          <!--              <el-radio :label="2">eMES密码</el-radio>-->
          <!--              <el-radio :label="1">OA密码</el-radio>-->
          <!--            </el-radio-group>-->
          <!--          </div>-->
          <div class="login-btn">
            <el-button
                :loading="loading"
                size="medium"
                type="primary"
                @click="login">
              立即登录
            </el-button>
          </div>
          <el-button
              type="text"
              class="changePwd"
              size="medium"
              style="float: right"
              @click="changePwd">
            修改密码
          </el-button>
        </el-form>
      </el-card>
    </div>
    <div class="copyright"/>
    <change-pwd ref="changePwdDialog"/>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import ChangePwd from "@/views/main/ChangePwd.vue";

  const storage = window.localStorage;
  export default {
    components: {ChangePwd},
    data() {
      const isDev = process.env.NODE_ENV === "development";
      return {
        dialogVisible: false,
        countdownSeconds: 60,
        sendMsgBtnDisabled: false,
        sendMsgBtnText: "发送短信",
        sendMsgBtnLoading: false,
        registerSendMsgBtnLoading: false,
        captchaImg: "",
        showCaptcha: loginUtil.isShowCaptcha(),
        user: {
          username: isDev ? "admin" : "",
          password: isDev ? "Step2026." : "",
          captchaKey: "",
          captcha: "",
          loginType: 2,
        },
        registerUser: {
          userName: "",
          password: "",
          mobile: "",
          code: "",
        },
        findPassword: {
          username: "",
          mobile: "",
          code: "",
          newPassword: "",
        },
        rules: {
          username: {required: true, message: "账号不能为空", trigger: "blur"},
          password: {required: true, message: "密码不能为空", trigger: "blur"},
          captcha: {required: true, message: "验证码为4位", trigger: "blur", max: 4, min: 4},
        },
        loading: false,
      };
    },
    mounted() {
      if (this.showCaptcha) {
        this.getCaptcha();
      }
    },
    methods: {
      login() {
        const hasRepeatedDigits = /(\d)\1{2}/;
        if (hasRepeatedDigits.test(this.user.password)) {
          return this.$message.error("按照监管要求，密码禁止出现重复数字，请修改密码！");
        }
        const hasSequentialDigits = /(?:012|123|234|345|456|567|678|789|987|876|765|654|543|432|321|210)/;
        if (hasSequentialDigits.test(this.user.password)) {
          return this.$message.error("按照监管要求，密码禁止出现连续数字，请修改密码！");
        }
        // eslint-disable-next-line no-useless-escape
        const passwordRegex = /^(?!.*(\d)\1{2})(?!.*(?:012|123|234|345|456|567|678|789|987|876|765|654|543|432|321|210))(?:(?=.*[A-Z])(?=.*[a-z])(?=.*\d)|(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])|(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])|(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])).{8,20}$/;
        if (!passwordRegex.test(this.user.password)) {
          return this.$message.error("按照监管要求，密码必须包含【大写字母、小写字母、数字、符号】中的3种组合，长度为8-20位。");
        }
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.loading = true;
            this.$http
              .post("basic", "account/loginWithCaptcha", this.user)
              .then(data => {
                storage.clear();
                this.loading = false;
                loginUtil.login(data);
                loginUtil.hideCaptcha();
                this.showCaptcha = false;
                this.$router.push({path: "/"});
              })
              .catch(error => {
                this.loading = false;
                const status = error.response.data.status;
                if (status === 428) {
                  this.$confirm(error.response.data.message, "提示", {
                    type: "warning",
                    confirmButtonText: "更改密码",
                  }).then(() => {
                    this.changePwd();
                  });
                } else {
                  loginUtil.showCaptcha();
                  this.showCaptcha = true;
                  this.getCaptcha();
                  this.user.captcha = "";
                }
              });
          }
        });
      },
      changePwd() {
        this.$refs.changePwdDialog.open(this.user.username);
      },
      getCaptcha() {
        this.$http.get("basic", "captcha/getBase64")
          .then(data => {
            this.user.captchaKey = data.key;
            this.captchaImg = data.img;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
.el-input--medium .el-input__inner {
  height: 46px !important;
  line-height: 46px !important;
}

.el-input-group > .el-input-group__prepend {
  width: 60px !important;
}

.login {
  width: 100%;
  height: 100%;
  background: url("/img/newlogin.png") center;
  background-size: cover;
  position: relative;
  text-align: center;

  .login-top {
    width: 100%;
    text-align: center;
    height: 18%;
  }

  &-con {
    margin: 0 auto;
    width: 35%;

    .bgImg {
      margin: 5% auto;
    }
  }

  @media (max-width: 1199px) {
    &-con {
      width: 45%;
    }
  }
  @media (min-width: 1801px) and (max-width: 2200px) {
    &-con {
      width: 30%;
    }
  }
  @media (min-width: 2201px) {
    &-con {
      width: 25%;
    }
  }

  .copyright {
    position: absolute;
    text-align: center;
    left: 10%;
    right: 10%;
    bottom: 20px;
    color: white;
  }

  .login-btn {
    width: 390px;
    height: 90px;
    margin: 0 auto;
    background: url("/img/newloginBtn.png") no-repeat center;
    /*background-size: cover;*/
    button {
      width: 45%;
      line-height: 80px;
      font-size: 20px;
      border: none;
      background: none;
      padding: 0;
    }

    button:nth-child(1) {
      color: #ffffff;
      margin-left: 4.5%;
    }
  }

  @media (max-width: 959px) {
    .login-btn {
      width: 100%;
      height: 4.5em;
      margin: 0 auto;
      background: url("/img/newloginBtn.png") no-repeat center;
      /*background-size: cover;*/
      button {
        width: 45%;
        line-height: 4rem;
      }
    }
  }
}

</style>
